

export const ArrowLeftIcon = () => (
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.72066 16.3802L2.30249 9L9.72067 1.61976C10.0931 1.24922 10.0931 0.648444 9.72066 0.277904C9.3482 -0.0926369 8.74434 -0.092635 8.37189 0.277911L0.279335 8.32907C-0.0931133 8.69962 -0.0931134 9.30038 0.279335 9.67092L8.37188 17.7221C8.74433 18.0926 9.3482 18.0926 9.72065 17.7221C10.0931 17.3516 10.0931 16.7508 9.72066 16.3802Z" fill="#909090"/>
    </svg>
)

export const ArrowRightIcon = () => (
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.279334 1.61976L7.69751 9L0.279335 16.3802C-0.0931151 16.7508 -0.0931113 17.3516 0.279344 17.7221C0.651798 18.0926 1.25566 18.0926 1.62811 17.7221L9.72066 9.67093C10.0931 9.30038 10.0931 8.69962 9.72066 8.32908L1.62811 0.277912C1.25566 -0.0926343 0.651797 -0.0926361 0.279344 0.277904C-0.093112 0.648447 -0.0931158 1.24922 0.279334 1.61976Z" fill="#909090"/>
    </svg>
)

export const ArrowTopRightIcon = () => (
    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.55788 10.06L0.284091 8.78622L6.6772 2.38707H1.82351L1.83558 0.636363H9.70171V8.50852H7.93892L7.951 3.66087L1.55788 10.06Z" fill="#909090"/>
    </svg>
)

export const ArrowLeftIcon = () => (
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.72066 16.3802L2.30249 9L9.72067 1.61976C10.0931 1.24922 10.0931 0.648444 9.72066 0.277904C9.3482 -0.0926369 8.74434 -0.092635 8.37189 0.277911L0.279335 8.32907C-0.0931133 8.69962 -0.0931134 9.30038 0.279335 9.67092L8.37188 17.7221C8.74433 18.0926 9.3482 18.0926 9.72065 17.7221C10.0931 17.3516 10.0931 16.7508 9.72066 16.3802Z" fill="#909090"/>
    </svg>
)

export const ArrowRightIcon = () => (
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.279334 1.61976L7.69751 9L0.279335 16.3802C-0.0931151 16.7508 -0.0931113 17.3516 0.279344 17.7221C0.651798 18.0926 1.25566 18.0926 1.62811 17.7221L9.72066 9.67093C10.0931 9.30038 10.0931 8.69962 9.72066 8.32908L1.62811 0.277912C1.25566 -0.0926343 0.651797 -0.0926361 0.279344 0.277904C-0.093112 0.648447 -0.0931158 1.24922 0.279334 1.61976Z" fill="#909090"/>
    </svg>
)

export const ArrowTopRightIcon = () => (
    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.55788 10.06L0.284091 8.78622L6.6772 2.38707H1.82351L1.83558 0.636363H9.70171V8.50852H7.93892L7.951 3.66087L1.55788 10.06Z" fill="#909090"/>
    </svg>
)